import React from "react";

import { Popover } from "antd";

import { assertNever } from "../../../utils/obj";

import * as theme from "./Toolbar.css";

export type TextToolState =
    | { type: "ENABLED" }
    | { type: "DISABLED"; reason?: string };

interface TextToolProps {
    state: TextToolState;
    onClick: () => void;
    children: React.ReactNode;
}

export function TextTool({ state, children, onClick }: TextToolProps) {
    let classname = "";
    let content = children;
    switch (state.type) {
        case "ENABLED":
            classname = theme.textTool;
            break;
        case "DISABLED":
            classname = theme.disabledTextTool;
            if (state.reason !== undefined) {
                content = <Popover content={state.reason}>{children}</Popover>;
            }
            break;
        default:
            return assertNever(state);
    }
    const isEnabled = state.type === "ENABLED";
    return (
        <span
            className={classname}
            role="button"
            tabIndex={0}
            aria-disabled={!isEnabled}
            onClick={isEnabled ? onClick : undefined}
            onKeyDown={
                isEnabled
                    ? (event) => {
                          if (event.key === "Enter" || event.key === " ") {
                              event.preventDefault();
                              onClick();
                          }
                      }
                    : undefined
            }
        >
            {content}
        </span>
    );
}
